// FlixPlayer.js
'use strict';
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';

import FlixPlayer from '../component/FlixPlayer.jsx';

import setPlayerData from '../action/setPlayerData.js';
import fetchDrmLicenseAvailability from '../action/fetchDrmLicenseAvailability.js';
import toggleDisturbing from '../action/toggleDisturbing.js';
import checkUserFlixHelpId from '../action/checkUserFlixHelpId.js';
import updateEngagementData from '../action/updateEngagementData.js';

import getMessageData from '../selector/getMessageData.js';
import getMessageDuration from '../selector/getMessageDuration.js';
import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import getUrlTimecode from '../selector/getUrlTimecode.js';
import { getSplashVideo } from '../selector/getRemoteConfigComputedData.js';
import getListData from '../selector/getListData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getIsNewlyUnlockedMessage from '../selector/getIsNewlyUnlockedMessage.js';
import getAssetData from '../selector/getAssetData.js';
import getIsAesEncrypted from '../selector/getIsAesEncrypted.js';

import { getKeySystem } from '../resource/getDrmInfo.js';
import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';

import { breakpoint } from '../style/variables.js';

const mapStateToProps = (state, { messageId, location }) => {
  const [notificationId] =
    getListData(state, ['popupNotification', 'topVideo'], 'itemIds') || [];
  const senderId = getMessageData(state, messageId, 'senderId');
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const canViewMedia = getMessageData(state, messageId, 'canViewMedia');
  const viewScope = getMessageData(state, messageId, 'viewScope');
  const isPreview = viewScope === 'preview';
  const isUnlocked = viewScope === 'sd' || viewScope === 'hd';
  const shouldDisturb =
    isUnlocked && getOperationData(state, ['disturbing'], 'shouldDisturb');

  const assetIds = getMessageData(state, messageId, 'assetIds');
  const assetId = assetIds?.[0];
  const mediaType = assetId
    ? getAssetData(state, [assetId], 'contentType')
    : getMessageData(state, messageId, 'mediaType');

  const isAesEncrypted = getIsAesEncrypted(state, assetId);
  const hasBlurredUrl = Boolean(getAssetData(state, [assetId], 'blurredUrl'));
  const hasTrailer = Boolean(getMessageData(state, messageId, 'trailerUrl'));

  return {
    notificationId,
    meId: getMeData(state, 'id'),
    senderId,
    username: getMeData(state, 'username'),
    badges: getMessageData(state, messageId, 'badges'),
    // flixDetail will fetchUser, so FlixPlayer don't need to do that.
    senderName: getUserData(state, senderId, 'username'),
    duration: getMessageDuration(state, messageId, location?.pathname),
    isFullscreen: getOperationData(state, ['player'], 'isFullscreen'),
    isMuted: getOperationData(state, ['player'], 'isMuted'),
    volume: getOperationData(state, ['player'], 'volume'),
    isVideoControlDisplayed: getOperationData(
      state,
      ['player'],
      'isVideoControlDisplayed'
    ),
    controlDisplayedMessageId: getOperationData(
      state,
      ['player'],
      'controlDisplayedMessageId'
    ),
    isPreview,
    canViewMedia,
    shouldDisturb,
    isOnPostDetail: getIsMatchedPathname({
      pathname: location?.pathname,
      dataKey: 'isOnPostDetail',
    }),
    isOnMobile: deviceWidth <= breakpoint.tablet,
    timecode: getUrlTimecode(state),
    splashVideo: getSplashVideo(state),
    timestampOffsetMilliseconds: getTimestampOffset(
      state,
      Accuracy.MILLISECOND
    ),
    viewScope,
    isFree: getMessageData(state, messageId, 'unlockPrice') === 0,
    isNewlyUnlocked: getIsNewlyUnlockedMessage(state, messageId),
    mediaType,
    isAesEncrypted,
    hasBlurredUrl,
    hasTrailer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPlayerData: data => dispatch(setPlayerData(data)),
    fetchViewScope: ({ id }) =>
      dispatch(
        fetchDrmLicenseAvailability({
          messageId: id,
          keySystem: getKeySystem(),
        })
      ),
    toggleDisturbing: data => dispatch(toggleDisturbing(data)),
    checkUserFlixHelpId: () => dispatch(checkUserFlixHelpId()),
    updateEngagementData: data => dispatch(updateEngagementData(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FlixPlayer)
);
